// Descriptive Section Loader Component
import Spinner from "./Spinner";


const BORDER = "#dfe8e6";
const TEXT = "#3D4A52";


function SectionLoader({ label, minHeight = 200 }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight,
        width: "100%",
        background: "#fff",
        borderRadius: 14,
        border: `1px solid ${BORDER}`,
        padding: 24,
        boxSizing: "border-box",
      }}
    >
      <Spinner size={34} />
      <span style={{ marginTop: 12, fontSize: 13, fontWeight: 600, color: TEXT }}>{label}</span>
      <span style={{ fontSize: 11.5, color: "#9aa5a3", marginTop: 4 }}>Fetching latest data...</span>
    </div>
  );
}

export default SectionLoader;